export default "__VITE_ASSET__b4ff384e__"